import { render, staticRenderFns } from "./account_sidebar.vue?vue&type=template&id=66a6a3d1&scoped=true"
import script from "./account_sidebar.vue?vue&type=script&lang=js"
export * from "./account_sidebar.vue?vue&type=script&lang=js"
import style0 from "./account_sidebar.vue?vue&type=style&index=0&id=66a6a3d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6a3d1",
  null
  
)

export default component.exports